/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  function getCartCountFromDom() {
    var cartCountElement = document.querySelector('.header__cart-count');

    if (!cartCountElement) {
      return 0;
    }

    return parseInt(cartCountElement.textContent || '0', 10) || 0;
  }

  function applyCartCount(count) {
    var nextCount = parseInt(count, 10);

    if (isNaN(nextCount)) {
      return;
    }

    window.theme = window.theme || {};
    window.theme.cartCount = nextCount;

    document.querySelectorAll('.header__cart-count').forEach(function(element) {
      element.textContent = nextCount;
      element.style.transform = 'scale(1.18)';

      window.clearTimeout(element._cpCartCountTimer);
      element._cpCartCountTimer = window.setTimeout(function() {
        element.style.transform = '';
      }, 220);
    });
  }

  async function syncCartCount() {
    var cartUrl = window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart';
    var response = await fetch(cartUrl + '.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Cart sync failed');
    }

    var cart = await response.json();
    applyCartCount(cart.item_count || 0);
    return cart;
  }

  function bumpCartCount(quantity) {
    var currentCount = window.theme && typeof window.theme.cartCount !== 'undefined'
      ? parseInt(window.theme.cartCount, 10) || 0
      : getCartCountFromDom();

    applyCartCount(currentCount + (parseInt(quantity, 10) || 1));
  }

  window.CricketProCartSync = {
    applyCartCount: applyCartCount,
    bumpCartCount: bumpCartCount,
    syncCartCount: syncCartCount
  };

  document.documentElement.addEventListener('product:added', function(event) {
    var quantity = event && event.detail ? event.detail.quantity : 1;

    bumpCartCount(quantity);
    syncCartCount().catch(function() {});
  });

  document.documentElement.addEventListener('cart:refresh', function() {
    syncCartCount().catch(function() {});
  });
})();
